import React from "react";
import headerImg from '@images/contact-page-v2/image64.svg'

const HeaderImage=()=>{
    return <section className="topImage mb-5 container-v2">
    <div>
        <img src={headerImg} alt="Contact Img"/>
    </div>
</section>
}
export default HeaderImage;